type SvgProps = React.SVGProps<SVGSVGElement>;

export const Payment = (props: SvgProps) => {
  return (
    <svg
      {...props}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6687_4160)">
        <path
          d="M14.0002 2.33398H4.0835V3.50065H14.0002V2.33398Z"
          fill="#9A7AFF"
        />
        <path
          d="M14.0002 6.41602H4.0835V7.58269H14.0002V6.41602Z"
          fill="#9A7AFF"
        />
        <path d="M14.0002 10.5H4.0835V11.6667H14.0002V10.5Z" fill="#9A7AFF" />
        <path
          d="M1.16667 4.08333C1.811 4.08333 2.33333 3.561 2.33333 2.91666C2.33333 2.27233 1.811 1.75 1.16667 1.75C0.522334 1.75 0 2.27233 0 2.91666C0 3.561 0.522334 4.08333 1.16667 4.08333Z"
          fill="#9A7AFF"
        />
        <path
          d="M1.16667 8.16731C1.811 8.16731 2.33333 7.64498 2.33333 7.00065C2.33333 6.35632 1.811 5.83398 1.16667 5.83398C0.522334 5.83398 0 6.35632 0 7.00065C0 7.64498 0.522334 8.16731 1.16667 8.16731Z"
          fill="#9A7AFF"
        />
        <path
          d="M1.16667 12.2493C1.811 12.2493 2.33333 11.727 2.33333 11.0827C2.33333 10.4383 1.811 9.91602 1.16667 9.91602C0.522334 9.91602 0 10.4383 0 11.0827C0 11.727 0.522334 12.2493 1.16667 12.2493Z"
          fill="#9A7AFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_6687_4160">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
